<template>
  <div>
    <div class="top">
      <div>
        <label style="padding: 0 10px">名称</label>
        <el-select v-model="chartId" placeholder="请选择">
          <el-option v-for="(item, index) in options" :key="index" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div style="padding: 0 10px">
        <el-radio-group v-model="batteryType" size="small" style="display: none;">
          <el-radio-button label="电量"></el-radio-button>
          <el-radio-button label="负荷"></el-radio-button>
        </el-radio-group>
      </div>
      <div style="line-height: 32px;">
        <label style="padding: 0 10px">能源类型</label>
        <el-radio-group v-model="targetAPPtype" size="small"
          style="padding: 5px 15px;border-radius: 4px;border: 1px solid #DCDFE6;background: #FFF;">
          <el-radio :label="237">水</el-radio>
          <el-radio :label="36">电</el-radio>
          <el-radio :label="361">气</el-radio>
          <el-radio :label="362">汽</el-radio>
          <el-radio :label="1">折标煤</el-radio>
        </el-radio-group>
      </div>
      <div v-if="interval == '日'">
        <label style="padding: 0 10px">日期</label>
        <el-date-picker v-model="time" type="date" placeholder="选择日期">
        </el-date-picker>
      </div>
      <div style="margin-left: 10px;" v-if="interval == '月'">
        <label style="padding: 0 10px">日期从</label>
        <el-date-picker v-model="startTime" type="date" placeholder="选择日期" value-forma="timestamp">
        </el-date-picker>
        <label style="padding: 0 10px">至</label>
        <el-date-picker v-model="endTime" type="date" placeholder="选择日期" value-forma="timestamp">
        </el-date-picker>
      </div>
      <div v-if="interval == '年'">
        <label style="padding: 0 10px">日期从</label>
        <el-date-picker v-model="startMonthTime" type="month" placeholder="选择日期">
        </el-date-picker>
        <label style="padding: 0 10px">至</label>
        <el-date-picker v-model="endMonthTime" type="month" placeholder="选择日期">
        </el-date-picker>
      </div>
      <div style="padding: 0 10px">
        <el-button type="primary" size="small" @click="demand">查询</el-button>
      </div>
    </div>
    <div>
      <div id="chart_example" ref="homePage" :style="{ height: heights + 'px' }"></div>
    </div>
    <!-- <div>
      <div style="display: flex; margin-bottom: 10px">
        <div class="div"></div>
        上下级节点计量差大于20%
      </div>
      <div style="display: flex">
        <div class="div" style="background-color: rgb(245, 171, 24)"></div>
        上下级节点计量差大于10%
      </div>
    </div> -->
  </div>
</template>

<script>
  import * as echarts from "echarts";
  var myChart;
  export default {
    data () {
      return {
        heights: '', //高
        chartId: "", //类型
        batteryType: "电量", //电量类型
        interval: "月", //时间间隔
        targetAPPtype: 36,//能源类型
        time: new Date(), //日 日期
        startTime: new Date(), //月 开始时间
        endTime: new Date(), //月 结束时间
        startMonthTime: "", //年 开始时间
        endMonthTime: "", // 年 结束时间
        options: [],
        option: {
          tooltip: {
            trigger: "item",
            triggerOn: "mousemove",
          },
          series: [
            {
              type: "tree",
              data: [],
              top: "1%",
              left: "7%",
              bottom: "1%",
              right: "20%",
              symbolSize: 7,
              roam: true,
              initialTreeDepth: -1,//树状图-1默认张开所有节点
              label: {
                fontSize: 14,
                position: "bottom",
                verticalAlign: "middle",
                align: "center",
              },
              leaves: {
                label: {
                  position: "right",
                  verticalAlign: "middle",
                  align: "left",
                },
              },
              emphasis: {
                focus: "descendant",
              },
              itemStyle: {
                normal: {
                  lineStyle: {
                    width: 5,
                    color: "#1890FF",
                    borderColor: "#1890FF",
                  },
                },
              },
              expandAndCollapse: true,
              animationDuration: 550,
              animationDurationUpdate: 750,
            },
          ],
        },
      };
    },
    created () {
      this.heights=`${document.documentElement.clientHeight}`-100
    },
    mounted () {
      this.init();
      //获取所有能流图
      this.getEnergyFlowChartsByUnitId();
      // this.startTimes();
      this.startMonthTimes();
      //this.getAreaDeviceEnergy("custom", 36, new Date(new Date().toLocaleDateString()).getTime(), Date.parse(new Date()));
      // console.log(new Date(new Date().toLocaleDateString()).getTime())
    },
    // watch: {
    //   heights: function () {
    //     this.changeFixed(this.heights);
    //     console.log(this.heights)
    //   },
    // },
    methods: {
      getEnergyFlowChartsByUnitId () {
        this.$api.energyFlowApi.getEnergyFlowChartsByUnitId(res => {
          this.options=res;
          if(res.length>0) {
            this.chartId=res[0].id
            this.demand()
          }
        })
      },
      //查询
      demand () {
        let type=''
        if(this.targetAPPtype==1) {
          type='zbm'
        } else {
          type=this.targetAPPtype
        }
        if(!this.chartId) {
          this.$message({
            message: '请选择名称',
            type: 'warning'
          });
          return
        }
        if(!this.startTime.getTime()&&!this.endTime.getTime()) {
          this.$message({
            message: '请选择时间',
            type: 'warning'
          });
          return
        }

        this.$dialogMethod.showLoading("正在查询")
        this.$api.energyFlowApi.getEnergyFlowChart(this.chartId,this.startTime.getTime(),this.endTime.getTime(),type,res => {
          console.log(res)
          let data=this.deviceList(res);
          this.makeTree([data])
          this.option.series[0].data=[data];
          myChart.clear()
          myChart.setOption(this.option,true);
          if(this.option) {
            this.$dialogMethod.closeLoading()
          }
        })
      },
      //渲染树形图
      // getAreaDeviceEnergy(dayType, appTypeNos, startTime, endTime) {
      //   this.$dialogMethod.showLoading("正在查询")
      //   this.$api.deviceApi.getAreaDeviceEnergy(
      //     dayType,
      //     appTypeNos,
      //     startTime,
      //     endTime,
      //     (res) => {
      //       let data = this.deviceList(res);
      //       this.makeTree([data])
      //       this.option.series[0].data = [data];
      //       myChart.setOption(this.option);
      //       this.$dialogMethod.closeLoading()
      //     }
      //   );
      // },
      //递归修改数据
      makeTree (arr) {
        for(var i=0;i<arr.length;i++) {
          // if(arr[i].value > 20){
          //   arr[i].label = {
          //     position: ["50%", "450%"],
          //     verticalAlign: "middle",
          //     align: "center",
          //     color: "#FFF",
          //     backgroundColor: "#F53131",
          //     borderColor: "#8C8D8E",
          //     borderRadius: 5,
          //     padding: [10, 15]
          //   };
          // }else if(arr[i].value < 20 && arr[i].value == 10){
          //   arr[i].label = {
          //     position: ["50%", "450%"],
          //     verticalAlign: "middle",
          //     align: "center",
          //     color: "#FFF",
          //     backgroundColor: "#F53131",
          //     borderColor: "#8C8D8E",
          //     borderRadius: 5,
          //     padding: [10, 15]
          //   };
          // }
          let a=''
          if(this.targetAPPtype!=1) {
            a=arr[i].perData*100
          } else {
            a=arr[i].standardPerData*100
          }
          let b=a? ', '+a.toFixed(2)+'%':''
          if(arr[i].entityName=='EnergyFlowChartDevice') {
            arr.splice(i,1);
            i--
            // arr[i].show =  'false',
            //   arr[i].lineStyle = {
            //     color: "red"
            //   }
          } else {
            let dw=this.targetAPPtype==36? 'kwh':this.targetAPPtype==1? 'T':this.targetAPPtype==362? 'kg':'m³'
            let data=''
            let c=''
            if(this.targetAPPtype==1) {
              data=arr[i].standardData? arr[i].standardData:0
              c=arr[i].lossStandardEnergy||arr[i].lossStandardEnergy==0? arr[i].lossStandardEnergy+dw:''
            } else {
              data=arr[i].data? arr[i].data:0
              c=arr[i].lossEnergy||arr[i].lossEnergy==0? arr[i].lossEnergy+dw:''
            }
            if(arr[i].children) {
              arr[i].name="\n\n\n"+arr[i].name+"\n"+data+dw+b+"\n"+c;
            } else {
              arr[i].name="\n"+arr[i].name+"\n"+data+dw+b+"\n"+c;
            }
            if(arr[i].children&&arr[i].children.length>0) {
              this.makeTree(arr[i].children);
            }
          }

        }
      },
      //转换数据
      deviceList (list) {
        let elementList=JSON.parse(
          JSON.stringify(list).replace(/next/g,"children")
        );
        elementList=JSON.parse(
          JSON.stringify(elementList).replace(/label/g,"name")
        );
        return elementList;
      },
      changeFixed (clientHeight) {
        //动态修改样式
        console.log(clientHeight);
        this.$refs.homePage.style.height=clientHeight+"px";
      },
      // 初始化图表
      init () {
        let data={
          name: "Throwable",
          children: [
            {
              name: "Error",
              children: [
                {
                  name: "VirtualMachineError",
                  children: [
                    {
                      name: "StackOverflowError",
                    },
                    {
                      name: "OutOfMemoryError",
                    },
                  ],
                },
                {
                  name: "AWTError",
                  children: [
                    {
                      name: "VirtualMachineError",
                    },
                    {
                      name: "AWTError",
                    },
                  ],
                },
              ],
            },
            {
              name: "Exception",
            },
          ],
        };
        this.option.series[0].data=[data];
        myChart=echarts.init(document.getElementById("chart_example"));
        myChart.setOption(this.option);
        myChart.resize();
        $(window).resize(function() {
          myChart.resize();
        });
      },
      //当月一号数据
      // startTimes() {
      //   let date = new Date();
      //   date.setDate(1);
      //   let month = parseInt(date.getMonth() + 1);
      //   let day = date.getDate();
      //   if (month < 10) month = "0" + month;
      //   if (day < 10) day = "0" + day;
      //   this.startTime = date.getFullYear() + "-" + month + "-" + day;
      // },
      //本月数据同上个月数据
      startMonthTimes () {
        let date=new Date();
        date.setDate(1);
        let month=parseInt(date.getMonth()+1);
        if(month<10) month="0"+month;
        this.startMonthTime=
          date.getFullYear()+"-"+parseInt(date.getMonth());
        this.endMonthTime=date.getFullYear()+"-"+month;
      },
    },
  };
</script>

<style scoped>
  .top {
    width: 100%;
    padding: 10px 0;
    border-bottom: 1px solid #d9d9d9;
    display: flex;
  }

  /deep/.el-input--suffix .el-input__inner {
    height: 32px;
    line-height: 32px;
  }

  /deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner {
    color: #1890ff;
    background-color: #fff;
    border-color: #1890ff;
  }

  /deep/.el-input__icon {
    line-height: 32px;
  }

  /deep/.el-button--small,
  .el-button--small.is-round {
    padding: 5px 15px;
  }

  .div {
    width: 25px;
    height: 17px;
    background-color: rgb(245, 49, 49);
    border-radius: 4px;
    margin: 0 10px;
  }
</style>